import { http } from '@haohan/clw-utils'

const URL = '/api/v1/projects'

export function queryStaticReList(projectId: string, queryParam: any) {
  return http.request({
    method: 'POST',
    url: `${URL}/${projectId}/storage/list`,
    data: queryParam
  })
}

export function deleteStaticFile(projectId: string, fileName: string) {
  return http.request({
    method: 'delete',
    url: `${URL}/${projectId}/storage/${fileName}`
  })
}

export function storageStat(projectId: string) {
  return http.request({
    method: 'get',
    url: `${URL}/${projectId}/storage/stat`
  })
}

export function reName(params) {
  const { projectId, id, name } = params
  return http.request({
    method: 'put',
    url: `${URL}/${projectId}/storage/${id}/rename/${name}`
  })
}
